export const CW_LINE_TYPES = [
  { v: "mens_singles", l: "Men's Singles" },
  { v: "womens_singles", l: "Women's Singles" },
  { v: "mens_doubles", l: "Men's Doubles" },
  { v: "womens_doubles", l: "Women's Doubles" },
  { v: "mixed_doubles", l: "Mixed Doubles" },
];

export const CW_LINE_FORMATS = [
  { v: "single", l: "Single game" },
  { v: "bo3", l: "Best of 3 sets" },
];

export const CW_SERIES = [
  { v: "single", l: "Single game", hint: "Pair #1 vs pair #1, one game." },
  { v: "bo3", l: "Best of 3 sets", hint: "Pair #i vs pair #i, best of 3 sets." },
  { v: "round_robin", l: "Round robin (all pairs)", hint: "Every pair plays every opposing pair; club point to the majority winner (remaining games skipped once clinched)." },
];
export const labelSeries = (v) => CW_SERIES.find((x) => x.v === v)?.l || v;

export const CW_STATUS_META = {
  draft: { l: "Draft", color: "#94a3b8" },
  published: { l: "Published", color: "#22c55e" },
  live: { l: "Live", color: "#06b6d4" },
  completed: { l: "Completed", color: "#eab308" },
};

export const CW_SCHEDULE_MODES = [
  { v: "by_round", l: "By round (Team vs Team)", hint: "Each fixture plays all its categories together." },
  { v: "by_category", l: "By category", hint: "Run one whole category at a time across the event." },
];
export const labelScheduleMode = (v) => CW_SCHEDULE_MODES.find((x) => x.v === v)?.l || v;

const map = (arr, v) => arr.find((x) => x.v === v)?.l || v;
export const labelLineType = (v) => map(CW_LINE_TYPES, v);
export const labelLineFormat = (v) => map(CW_LINE_FORMATS, v);

export const categoryLabel = (ln) => {
  const base = labelLineType(ln?.type);
  const withSkill = ln?.skill ? `${ln.skill} ${base}` : base;
  return ln?.entry_label ? `${withSkill} ${ln.entry_label}` : withSkill;
};

export const isDoublesLine = (type) => type?.endsWith("_doubles");

export const uid = (p = "id") => `${p}_${Date.now().toString(36)}${Math.random().toString(36).slice(2, 6)}`;
